import PropTypes from '@viking-eng/prop-types';
import React from 'react';
import './Container.css';

// Container - Overall container
// children: Whatever is inside the <Container></Container> tag
// noPadding: To avoid the padding for the container

function Container({ children, noPadding }) {
  return <div className={noPadding ? 'container p-0' : 'container'}>{children}</div>;
}

Container.propTypes = {
  noPadding: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Container.defaultProps = {
  noPadding: false,
};

export default Container;
